/** Responsive screen adjustments; the report itself uses the shared print design. */
export const WEB_SKIN_CSS = `
@media screen {
 .clinical .sheet { max-width:940px; }
 .clinical .report-page { box-shadow:0 8px 28px #0b243414; }
 .clinical .measurement-scroll { overflow-x:auto; }
 .clinical .measurement-summary table { min-width:600px; }
}
@media screen and (max-width:680px) {
 .clinical .report-page { padding:24px 16px; margin:12px 0; border-radius:0; }
 .clinical .view-grid,.clinical .pose-grid,.clinical .figrow.two,.clinical .figrow.three { grid-template-columns:1fr; }
 .clinical .overview-grid { grid-template-columns:1fr; }
 .clinical .report-cover .doctitle { font-size:25px; }
 .clinical table.ident th,.clinical table.ident td { padding:7px 5px; font-size:11px; }
 .clinical .report-cover .letterhead { gap:12px; }
 .clinical .report-cover .brand { width:125px; }
 .clinical h2.sec { font-size:22px; }
 .clinical .view-measurements table.data th,.clinical .view-measurements table.data td { font-size:11px; }
}
`;
export default WEB_SKIN_CSS;
